import { Component } from '@angular/core';
import { GlobalEventsManager } from './events-manager.component';
import { AuthGuard } from './shared/auth.guard';
import { PayeeApi } from './shared/sdk/services';
import { Router } from '@angular/router';

@Component({
  selector: 'navbar',
  templateUrl: './navbar.component.html',
  // styleUrls: ['./+home/home/style.css', './+home/home/css/responsive.css']
})

export class NavBarComponent {

  authenticated: boolean;
  homeDir:Array<any>;


  constructor(protected eventsManager: GlobalEventsManager,
              protected userApi: PayeeApi,
              protected router: Router,
              protected authGuard: AuthGuard
) {
    this.eventsManager.showNavBarEmitter.subscribe((mode)=>{
            // mode will be null the first time it is created, so you need to igonore it when null
            console.log("mode");
            console.log(mode);
            if (mode !== null) {
              console.log("mode !=null");
              
              this.authenticated = mode;
              this.router.navigate(['/']);
            } else {
              console.log("else");
              this.authenticated = this.authGuard.authenticated();
              console.log(this.authenticated);
            }
        });
    this.homeDir = ['/','/#benefits','/#features','/#products','/#testimonials','/#apply','/#contact'];

    

  }


  close(){
    document.getElementById('main-nav').removeAttribute("class");
  }

  logout() {
    this.eventsManager.logout(true);
    document.getElementById('main-nav').removeAttribute("class");
  }

  isHome(){
    return (this.homeDir.indexOf(this.router.url ) >= 0 );
  }
}
